// gsPayLookup.js

const gsPayTable = {
    1: [22584, 23341, 24092, 24840, 25589, 26028, 26771, 27519, 27550, 28248],
    2: [25393, 25997, 26839, 27550, 27858, 28677, 29496, 30315, 31134, 31953],
    3: [27708, 28632, 29556, 30480, 31404, 32328, 33252, 34176, 35100, 36024],
    4: [31103, 32140, 33177, 34214, 35251, 36288, 37325, 38362, 39399, 40436],
    5: [34799, 35959, 37119, 38279, 39439, 40599, 41759, 42919, 44079, 45239],
    6: [38791, 40084, 41377, 42670, 43963, 45256, 46549, 47842, 49135, 50428],
    7: [43106, 44543, 45980, 47417, 48854, 50291, 51728, 53165, 54602, 56039],
    8: [47738, 49329, 50920, 52511, 54102, 55693, 57284, 58875, 60466, 62057],
    9: [52727, 54485, 56243, 58001, 59759, 61517, 63275, 65033, 66791, 68549],
    10: [58064, 59999, 61934, 63869, 65804, 67739, 69674, 71609, 73544, 75479],
    11: [63795, 65922, 68049, 70176, 72303, 74430, 76557, 78684, 80811, 82938],
    12: [76463, 79012, 81561, 84110, 86659, 89208, 91757, 94306, 96855, 99404],
    13: [90925, 93956, 96987, 100018, 103049, 106080, 109111, 112142, 115173, 118204],
    14: [107446, 111028, 114610, 118192, 121774, 125356, 128938, 132520, 136102, 139684],
    15: [126384, 130597, 134810, 139023, 143236, 147449, 151662, 155875, 160088, 164301],
};

/**
 * Retrieves the annual pay for a given GS grade and step.
 *
 * @param {number} grade - The GS grade (1-15).
 * @param {number} step - The step within the grade (1-10).
 * @returns {number|null} - The corresponding annual pay or null if invalid input.
 */
export function getGSPay(grade, step) {
    if (gsPayTable[grade] && step >= 1 && step <= 10) {
        return gsPayTable[grade][step - 1]; // Adjust step (since array is 0-indexed)
    }
    return null; // Return null for invalid inputs
}